/*
 * @Description: 地图点位 marker 的 DOM 内容构建（驾驶舱 / 回放页共用）。
 *   图标 url / 名称为后端字段，用 textContent / 属性赋值避免 innerHTML 引入 XSS。
 *   样式见 .cockpit-poi（CockpitMap/index.scss，全局生效）。
 */
import { PoiItem } from '../types/poi.types'

/** 构建单个点位 marker 的 DOM（圆图标 + 右侧名称） */
export function buildPoiMarkerEl(poi: PoiItem): HTMLDivElement {
  const el = document.createElement('div')
  el.className = 'cockpit-poi'
  if (poi.iconUrl) {
    const img = document.createElement('img')
    img.className = 'cockpit-poi__icon'
    img.src = poi.iconUrl
    img.alt = ''
    el.appendChild(img)
  }
  const name = document.createElement('span')
  name.className = 'cockpit-poi__name'
  name.textContent = poi.name
  el.appendChild(name)
  return el
}
